import Vue from "vue";
import VueRouter from "vue-router";

// views
import Layout from "@/components/layout/Layout";
import Home from "@/views/Home";
import MyDashboard from "@/views/MyDashboard/MyDashboard";
import SalesDashboard from "@/views/SalesDashboard/SalesDashboard";
import CustomerSuccess from "@/views/CustomerSuccess/CustomerSuccess";
import UserView from "@/views/CustomerSuccess/UserView/UserView";
import TeamView from "@/views/CustomerSuccess/TeamView/TeamView";
import ProjectView from "@/views/CustomerSuccess/ProjectView/ProjectView";
import PlaygroundView from "@/views/CustomerSuccess/PlaygroundView/PlaygroundView";
import SubscriptionView from "@/views/CustomerSuccess/SubscriptionView";
import Account from "@/views/Account/Account";
import Login from "@/views/Login";
import Product from "@/views/Product/Product";
import Enterprise from "@/views/Enterprise/Enterprise";
import Marketing from "@/views/Marketing/Marketing";
import Tech from "@/views/Tech/Tech";
import Radio from "@/views/Tech/Radio";
import DevopsRollback from "@/views/DevOps/rollback";
import DevopsManagement from "@/views/DevOps/management";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    name: "Layout",
    component: Layout,
    children: [
      {
        path: "/",
        name: "Home",
        component: CustomerSuccess,
      },
      {
        path: "/account",
        name: "Account",
        component: Account,
      },
      {
        path: "/dashboard",
        name: "Dashboard",
        component: MyDashboard,
      },
      {
        path: "/customers/:query?",
        name: "Customers",
        component: CustomerSuccess,
        children: [
          { path: "/customers/user/:query", component: UserView },
          { path: "/customers/team/:query", component: TeamView },
          { path: "/customers/project/:query", component: ProjectView },
          { path: "/customers/playground/:query", component: PlaygroundView },
          {
            path: "/customers/stripesubscription/:query",
            component: SubscriptionView,
            props: { subscriptionType: "stripe" },
          },
          {
            path: "/customers/paypalsubscription/:query",
            component: SubscriptionView,
            props: { subscriptionType: "paypal" },
          },
        ],
      },
      {
        path: "/product/:tab?",
        name: "Product",
        component: Product,
      },
      {
        path: "/enterprise/:tab?",
        name: "Enterprise",
        component: Enterprise,
      },
      {
        path: "/bi",
        name: "Business Inteligence",
        component: Home,
      },
      {
        path: "/sales",
        name: "Sales",
        component: SalesDashboard,
      },
      {
        path: "/marketing/:tab?",
        name: "Marketing",
        component: Marketing,
      },
      {
        path: "/tech/:tab?",
        name: "Tech",
        component: Tech,
      },
      {
        path: "/radio",
        name: "Radio",
        component: Radio,
      },
      {
        path: "/devops/rollback",
        name: "DevopsRollback",
        component: DevopsRollback,
      },

      {
        path: "/devops/management",
        name: "DevopsManagement",
        component: DevopsManagement,
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (!localStorage.token && to.path !== "/login") next("/login");
  else next();
});

export default router;
